import React from 'react';
import { Button, Text, withTheme } from '@rneui/themed';
import { JumpType } from '@annunciate/core';
import { useJump } from '../../hooks/player';
import { FAIcon } from '../elements';
export const UnthemedJumpButton = ({ containerStyle = {}, iconStyle = {}, textStyle = {}, customIcon, direction, size, }) => {
    const { jump, jumpForward, jumpBackward } = useJump();
    const type = direction === 'forward' ? JumpType.FORWARD : JumpType.BACKWARD;
    const interval = type === JumpType.FORWARD ? jumpForward : jumpBackward;
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "clear", onPress: () => jump(type), containerStyle: containerStyle },
            customIcon ? (React.createElement(React.Fragment, null, customIcon)) : (React.createElement(FAIcon, { name: type === JumpType.FORWARD ? 'redo-alt' : 'undo-alt', size: size, style: iconStyle })),
            React.createElement(Text, { style: textStyle }, interval))));
};
export const JumpButton = withTheme(UnthemedJumpButton, 'JumpButton');
//# sourceMappingURL=JumpButton.js.map